import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$slug/department/')({
  beforeLoad: ({ params }) => {
    // Department is a tabbed landing page; default to the members tab.
    throw redirect({
      to: '/$slug/department/members',
      params: { slug: params.slug }
    });
  }
});
